import Decimal from "decimal.js";

export class DecimalUtility {
  static roundUnacceptableError(value: number): number {
    return DecimalUtility.hasUnacceptableError(value)
      ? DecimalUtility.roundAcceptableDecimal(value)
      : value;
  }

  private static hasUnacceptableError(value: number): boolean {
    const numberAsString = value.toString();
    const numberOfDecimalPlaces = numberAsString.length - numberAsString.indexOf(".") - 1;
    // 循環小数以外は対象外とするように暫定対応
    if (numberOfDecimalPlaces < 10) { return false; }
    return !!value.toString().match(/[0-9]*\.(([1-9]*00+[0-9]+)|([0-8]*99+[0-9]+)|(0[1-9]*00+[0-9]+)|(9[0-8]*99+[0-9]+))$/);
  }

  private static toNumberOfDecimalPlacesToRound(value: number): number {
    const numberAsString = value.toString();
    const numberOfDecimalPlaces = numberAsString.length - numberAsString.indexOf(".") - 1;
    return ((1 < numberOfDecimalPlaces) && (numberOfDecimalPlaces < numberAsString.length - 1))
      ? (numberOfDecimalPlaces - 2)
      : -1;
  }

  private static roundAcceptableDecimal(value: number): number {
    const place = DecimalUtility.toNumberOfDecimalPlacesToRound(value);
    return this.roundOff(value, place);
  }
  
  /**
   * 指定の桁数で四捨五入する
   */
  public static roundOff(value: number, place: number): number {
    const powered = new Decimal(Math.pow(10, place));
    return new Decimal(value).mul(powered).round().div(powered).toNumber();
  }

  /**
   * 指定の桁数で切り上げする
   */
  public static roundUp(value: number, place: number): number {
    const powered = new Decimal(Math.pow(10, place));
    return new Decimal(value).mul(powered).ceil().div(powered).toNumber();
  }

  /**
   * 指定の桁数で切り捨てする
   */
  public static roundDown(value: number, place: number): number {
    const powered = new Decimal(Math.pow(10, place));
    return new Decimal(value).mul(powered).floor().div(powered).toNumber();
  }

  /**
   * 小数点以下の0を付加した文字列にする(本来であれば値とテキストのプロパティを分けたい)
   */
  public static format(value: number, roundingPosition: number): number | string {
    if (value === null || value === undefined || typeof(value) !== "number") { return value; }
    if (!roundingPosition || roundingPosition <= 1) { return value; }
    let text = value.toString();
    const periodIndex = text.indexOf(".");
    const afterDecimalPointLength = (periodIndex < 0) ? 0 : text.length - periodIndex - 1;
    const zeroAddLength = roundingPosition - 1 - afterDecimalPointLength;
    if (zeroAddLength <= 0) { return text; }
    if (periodIndex < 0) {
      // 小数点のピリオドが無い場合は追加する
      text = text + ".";
    }
    for (let i = 0; i < zeroAddLength; ++i) {
      text = text + "0";
    }
    return text;
  }
}
